import { useCallback } from "react";
import useAuth from "./useAuth";

export default function useConfirmPasswordReset() {
  const { auth } = useAuth();

  const verifyCode = useCallback(
    async (oobCode: string) => {
      if (!auth) {
        throw new Error("Auth is not initialized");
      }
      const { verifyPasswordResetCode } = await import("firebase/auth");
      return verifyPasswordResetCode(auth, oobCode);
    },
    [auth],
  );

  const confirmReset = useCallback(
    async (oobCode: string, password: string) => {
      if (!auth) {
        throw new Error("Auth is not initialized");
      }
      const { confirmPasswordReset } = await import("firebase/auth");
      await confirmPasswordReset(auth, oobCode, password);
    },
    [auth],
  );

  return { verifyCode, confirmReset };
}
